import GUI from "lil-gui";

export class AsciiRenderer {
  constructor() {
    this.renderEl = document.querySelector(".ascii-render");

    this.chars = ["@", "#", "S", "%", "?", "*", "+", ";", ":", ",", "."];

    this.parameters = {
      pixelSize: 8,
    };

    this.createMessageElement();
    this.getMediaStream();
    this.createCanvas();
    // this.createGUI();
    this.onResize();
    window.addEventListener("resize", () => this.onResize());
  }

  getMediaStream() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      this.showMessage(
        "Aucune webcam détectée ou API non supportée par ce navigateur.",
      );
      return;
    }

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        this.hideMessage();
        this.video = document.createElement("video");
        this.video.srcObject = stream;
        this.video.autoplay = true;
        this.video.playsInline = true;

        this.video.onloadedmetadata = () => {
          this.video.play();
          this.render();
        };
      })
      .catch((err) => {
        console.error(err);
        let msg;
        if (err.name === "NotAllowedError" || err.name === "SecurityError") {
          msg = "Accès à la webcam refusé... snif :(";
        } else if (
          err.name === "NotFoundError" ||
          err.name === "OverconstrainedError"
        ) {
          msg = "Aucune webcam disponible :(";
        } else {
          msg = "Erreur lors de l'accès à la webcam :(";
        }
        this.showMessage(msg);
      });
  }

  createMessageElement() {
    this.messageEl = document.createElement("div");
    this.messageEl.className = "camera-message";
    this.messageEl.setAttribute("role", "alert");
    this.messageEl.style.display = "none";
    document.body.appendChild(this.messageEl);
  }

  showMessage(msg) {
    if (!this.messageEl) this.createMessageElement();
    this.messageEl.textContent = msg;
    this.messageEl.style.display = "block";
  }

  hideMessage() {
    if (this.messageEl) this.messageEl.style.display = "none";
  }

  onResize() {
    const charW = this.parameters.pixelSize;
    const charH = this.parameters.pixelSize * 1.9;

    this.cols = Math.floor(window.innerWidth / charW);
    this.rows = Math.floor(window.innerHeight / charH);

    this.canvas.width = this.cols;
    this.canvas.height = this.rows;
  }

  createCanvas() {
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
  }

  convertPixelsToChar(pixels, width) {
    let ascii = "";
    for (let y = 0; y < this.rows; y++) {
      let line = "";
      for (let x = 0; x < this.cols; x++) {
        const i = (y * width + x) * 4; // <— CORRECT
        const r = pixels[i];
        const g = pixels[i + 1];
        const b = pixels[i + 2];
        const brightness = (r + g + b) / 3;

        const idx = Math.floor(
          (1 - brightness / 255) * (this.chars.length - 1),
        );

        line += this.chars[idx];
      }
      ascii += line + "\n";
    }
    return ascii;
  }

  createGUI() {
    this.gui = new GUI();

    this.gui
      .add(this.parameters, "pixelSize", 4, 30, 1)
      .name("Pixel Size")
      .onChange(() => this.onResize());
  }

  render() {
    if (!this.video) return;

    this.ctx.drawImage(this.video, 0, 0, this.cols, this.rows);

    const image = this.ctx.getImageData(0, 0, this.cols, this.rows);
    const string = this.convertPixelsToChar(image.data, this.cols);

    this.renderEl.textContent = string;

    requestAnimationFrame(() => this.render());
  }
}
